import { Entity } from "game-common/models"
import { BonecallerAttack } from "game-common/bonecaller_combat"
import { radians_to_cardinal_dir } from "game-common/util"

export interface BonecallerBodyPose {
    action: string
    progress: number
}

/** Scrub existing LPC staff frames against authoritative phase age, never a local attack clock. */
export class BonecallerPose {
    private attack?: BonecallerAttack
    private receivedAt = 0
    private direction = "front"

    update = (entity: Entity, now: number): BonecallerBodyPose | undefined => {
        if (!entity.bonecallerCombatRadius || entity.hp <= 0 || entity.isDead()) {
            this.attack = undefined
            return undefined
        }
        if (this.attack !== entity.bonecallerAttack) this.receivedAt = now
        this.attack = entity.bonecallerAttack
        const attack = this.attack
        if (!attack || attack.remainingMs <= now - this.receivedAt) {
            // Stale windup data must not play a strike while waiting for the next server message.
            return { action: `idle-${this.direction}`, progress: 0 }
        }
        this.direction = radians_to_cardinal_dir(attack.angle)
        const t = Math.max(0, Math.min(1, 1 - (attack.remainingMs - now + this.receivedAt) / attack.durationMs))
        const progress = attack.phase === "anticipation" ? t * 0.15 :
            attack.phase === "windup" ? 0.15 + t * 0.15 :
            attack.phase === "impact" ? 0.3 + t * 0.45 : 0.75 * (1 - t)
        return { action: `thrust-${this.direction}`, progress }
    }
}
